import {useEffect, useState} from 'react'

/** True when the viewport is at/under the breakpoint (default 768px). Used to
 *  swap admin tables for stacked cards and tighten layouts on phones. */
export const useIsMobile = (query = '(max-width: 768px)'): boolean => {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  )
  useEffect(() => {
    const mq = window.matchMedia(query)
    const onChange = () => setIsMobile(mq.matches)
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [query])
  return isMobile
}
